var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrrowRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 50719"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 16358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24a11.61 11.61 0 0 1-4.684-.95 12.2 12.2 0 0 1-3.8-2.567 12.2 12.2 0 0 1-2.567-3.8A11.61 11.61 0 0 1 0 12a11.61 11.61 0 0 1 .95-4.684 12.2 12.2 0 0 1 2.567-3.8 12.2 12.2 0 0 1 3.8-2.567A11.611 11.611 0 0 1 12 0v2a9.633 9.633 0 0 0-7.067 2.934A9.633 9.633 0 0 0 2 12a9.611 9.611 0 0 0 2.934 7.09A9.671 9.671 0 0 0 12 22Zm5.767-5.767-1.4-1.433 3.767-3.767H8v-2h12.134l-3.767-3.8 1.4-1.4 6.2 6.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrrowRead);
export default __webpack_public_path__ + "static/media/right-arrrow-read.54cd166d233a2ad6214b606854fa4da4.svg";
export { ForwardRef as ReactComponent };